import * as React from 'react';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import './Button.css';

interface Props {
  onClick: (item?) => void;
  text: string | string[] | (string | React.ReactElement<any>)[];
  customClass?: string;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  tabIndex?: number;
}

export const Button: FunctionComponent<Props> = props => {
  const { customClass, disabled, text, onClick, type, tabIndex } = props;
  const isCreateAction =
    typeof text === 'string' && /^(add|create)\s+/i.test(text.trim()) && !/^create like\b/i.test(text.trim());
  const hasExplicitBtnVariant = /\b(btn-(primary|secondary|success|danger|warning|info|light|dark|outline-secondary|outline-primary|outline-success|outline-danger|outline-warning|outline-info|outline-light|outline-dark)|sit-btn)\b/.test(
    customClass || ''
  );

  const buttonClass = classNames('btn', hasExplicitBtnVariant ? '' : 'btn-primary', customClass);

  return (
    <button className={buttonClass} disabled={disabled} onClick={onClick} type={type} tabIndex={tabIndex}>
      {isCreateAction && (
        <span className="sitButtonCreateIcon" aria-hidden="true">
          +
        </span>
      )}
      {text}
    </button>
  );
};

Button.displayName = 'Button';

Button.defaultProps = {
  disabled: false,
  type: 'button'
};
